
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Loader from 'components/Loader'

export default class Iframe extends React.Component {
  static propTypes = {
    src: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    scale: PropTypes.number
  }

  constructor(props) {
    super(props)
    this.state = {
      loaded: false
    }
  }

  render() {
    const {width, height, scale, src} = this.props
    const {loaded} = this.state
    const top = -(height / 2 - (height * scale / 2))
    const left = -(width / 2 - (width * scale / 2))

    return (
      <div
        className='iframe_container'
        style={{
          width: width * scale,
          height: height * scale
        }}
      >
        {loaded ? <div className='iframe_error'>We couldn{"'"}t show you a preview</div> : <Loader />}
        <iframe
          className='iframe'
          style={{
            transform: `scale(${scale})`,
            width,
            height,
            top,
            left
          }}
          src={src}
          ref={iframe => { this.iframe = iframe }}
          onLoad={this.onLoad}
        />
      </div>
    )
  }

  onLoad = () => {
    this.setState({
      loaded: true
    })
  }
}



// WEBPACK FOOTER //
// ./client/components/Iframe/index.js